import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  headerRow: {
    border: '1px #D1D1D1 solid'
  }
};

const enhance = compose();

const UserTableHead = enhance(({ order, orderBy, onRequestSort, classes }) => {
  return (
    <TableHead>
      <TableRow className={classes.headerRow}>
        <TableCell sortDirection={orderBy === 'shopId' ? order : false}>
          <TableSortLabel
            active={orderBy === 'shopId'}
            direction={order}
            onClick={() => {
              onRequestSort('shopId');
            }}
          >
            連絡番号
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'shopName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'shopName'}
            direction={order}
            onClick={() => {
              onRequestSort('shopName');
            }}
          >
            状況
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'menuId' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuId'}
            direction={order}
            onClick={() => {
              onRequestSort('menuId');
            }}
          >
            連絡操作
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'menuName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuName'}
            direction={order}
            onClick={() => {
              onRequestSort('menuName');
            }}
          >
            連絡があった日
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'menuChildType' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuChildType'}
            direction={order}
            onClick={() => {
              onRequestSort('menuChildType');
            }}
          >
            来店希望日
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'price' ? order : false}>
          <TableSortLabel
            active={orderBy === 'price'}
            direction={order}
            onClick={() => {
              onRequestSort('price');
            }}
          >
            連絡者名
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'taxTypeStr' ? order : false}>
          <TableSortLabel
            active={orderBy === 'taxTypeStr'}
            direction={order}
            onClick={() => {
              onRequestSort('taxTypeStr');
            }}
          >
            電話番号
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'taxTypeStr' ? order : false}>
          <TableSortLabel
            active={orderBy === 'taxTypeStr'}
            direction={order}
            onClick={() => {
              onRequestSort('taxTypeStr');
            }}
          >
            領収書番号
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'taxTypeStr' ? order : false}>
          <TableSortLabel
            active={orderBy === 'taxTypeStr'}
            direction={order}
            onClick={() => {
              onRequestSort('taxTypeStr');
            }}
          >
            店舗ID
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'taxTypeStr' ? order : false}>
          <TableSortLabel
            active={orderBy === 'taxTypeStr'}
            direction={order}
            onClick={() => {
              onRequestSort('taxTypeStr');
            }}
          >
            店舗名
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'taxTypeStr' ? order : false}>
          <TableSortLabel
            active={orderBy === 'taxTypeStr'}
            direction={order}
            onClick={() => {
              onRequestSort('taxTypeStr');
            }}
          >
            メニュー名
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'taxTypeStr' ? order : false}>
          <TableSortLabel
            active={orderBy === 'taxTypeStr'}
            direction={order}
            onClick={() => {
              onRequestSort('taxTypeStr');
            }}
          >
            税込価格
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'taxTypeStr' ? order : false}>
          <TableSortLabel
            active={orderBy === 'taxTypeStr'}
            direction={order}
            onClick={() => {
              onRequestSort('taxTypeStr');
            }}
          >
            メッセージ
          </TableSortLabel>
        </TableCell>
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(UserTableHead);
